/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "1d50337d0af797f26db787f0d482a702b5f4e7e8";
